import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: [],
    standalone: false
})
export class LoginComponent implements OnInit {
  public errorMessage: string;

  public constructor(
    private readonly titleService: Title,
    private readonly userService: UserService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly errorService: ErrorService) { }

  public ngOnInit() {
    this.titleService.setTitle("Sign In");

    this.userService.login()
      .subscribe(succeeded => {
        if (succeeded) {
          this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        } else {
          this.errorMessage = "Unknown error during sign in.";
        }
      }, error => {
          this.errorMessage = this.errorService.getErrorMessage(error);
      });
  }
}
